/**
 * motionTokens
 *
 * Pre-computed CSS transition strings and motion constants.
 * All values derived deterministically from operationalMotionTiming.
 */

import {
  SELECTION_TIMING,
  CONTINUITY_TIMING,
  REPLAY_TIMING,
  VERIFICATION_TIMING,
  GRAPH_TIMING,
  STRUCTURAL_TIMING,
} from './operationalMotionTiming.js';

/** CSS transition string for background-color selection */
export const TRANSITION_BG_SELECTION = `background-color ${SELECTION_TIMING.backgroundMs}ms ${SELECTION_TIMING.easing}`;

/** CSS transition string for border-left accent on selection */
export const TRANSITION_ACCENT_SELECTION = `border-color ${SELECTION_TIMING.accentMs}ms ${SELECTION_TIMING.easing}`;

/** CSS transition string for inspector content opacity */
export const TRANSITION_INSPECTOR_CONTENT = `opacity ${SELECTION_TIMING.inspectorContentMs}ms ${SELECTION_TIMING.easing}`;

/** CSS transition string for continuity overlay fade */
export const TRANSITION_CONTINUITY_OVERLAY = `opacity ${CONTINUITY_TIMING.overlayFadeMs}ms ${CONTINUITY_TIMING.easing}`;

/** CSS transition string for continuity state pulse (box-shadow) */
export const TRANSITION_CONTINUITY_PULSE = `box-shadow ${CONTINUITY_TIMING.statePulseMs}ms ${CONTINUITY_TIMING.easing}`;

/** CSS transition string for refusal marker settle */
export const TRANSITION_REFUSAL_SETTLE = `opacity ${CONTINUITY_TIMING.refusalSettleMs}ms ${CONTINUITY_TIMING.easing}, transform ${CONTINUITY_TIMING.refusalSettleMs}ms ${CONTINUITY_TIMING.easing}`;

/** CSS transition string for replay cursor */
export const TRANSITION_REPLAY_CURSOR = `opacity ${REPLAY_TIMING.cursorMoveMs}ms ${REPLAY_TIMING.easing}, transform ${REPLAY_TIMING.cursorMoveMs}ms ${REPLAY_TIMING.easing}`;

/** CSS transition string for verification badge */
export const TRANSITION_VERIFICATION_VALID = `opacity ${VERIFICATION_TIMING.validFadeMs}ms ${VERIFICATION_TIMING.easing}`;

/** CSS transition string for invalid verification */
export const TRANSITION_VERIFICATION_INVALID = `opacity ${VERIFICATION_TIMING.invalidTransitionMs}ms ${VERIFICATION_TIMING.easing}`;

/** CSS transition string for graph node selection */
export const TRANSITION_GRAPH_NODE = `stroke-width ${GRAPH_TIMING.nodeSelectMs}ms ${GRAPH_TIMING.easing}`;

/** CSS transition string for graph edge emphasis */
export const TRANSITION_GRAPH_EDGE = `stroke-width ${GRAPH_TIMING.edgeEmphasisMs}ms ${GRAPH_TIMING.easing}`;

/** CSS transition string for hover capsule */
export const TRANSITION_HOVER_CAPSULE = `opacity ${GRAPH_TIMING.capsuleFadeMs}ms ${GRAPH_TIMING.easing}`;

/** CSS transition string for structural collapse/expand */
export const TRANSITION_COLLAPSE = `opacity ${STRUCTURAL_TIMING.collapseMs}ms ${STRUCTURAL_TIMING.easing}`;

/** CSS transition string for tab switch */
export const TRANSITION_TAB_SWITCH = `opacity ${STRUCTURAL_TIMING.tabSwitchMs}ms ${STRUCTURAL_TIMING.easing}`;

/** Reduced-motion override: all transitions instant */
export const REDUCED_MOTION_OVERRIDE = '@media (prefers-reduced-motion: reduce) { * { transition-duration: 0.01ms !important; animation-duration: 0.01ms !important; } }';
